package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@JsExport
@Serializable
class IoTConnectivity(
    @SerialName("lastCheckedAt") val lastCheckedAt: Long? = null,
    @SerialName("status") val status: String
)
